import { useState } from 'react';
import { SkillsContext } from './SkillsContext';
import { SkillEnum, SkillModel } from '@/apiTypes/SkillsTypes';
import { CustomSkillData } from '@/pages/LegacySkills/AddCustomSkillForm.tsx';

export const SkillsProvider = ({ children }: { children: React.ReactNode }) => {
    const [stagedSkills, setStagedSkills] = useState<SkillModel[]>([]);
    const [stagedCustomSkills, setStagedCustomSkills] = useState<CustomSkillData[]>([]);
    const [creationType, setCreationType] = useState<'custom' | 'default' | undefined>(undefined);
    const [skillTypesFilter, setSkillTypesFilter] = useState<SkillEnum[]>([]);
    const [skillCategoryIdsFilter, setSkillCategoryIdsFilter] = useState<string[]>([]);
    const [occupationIdsFilter, setOccupationIdsFilter] = useState<string[]>([]);

    return (
        <SkillsContext.Provider value={{
            stagedSkills,
            setStagedSkills,
            stagedCustomSkills,
            setStagedCustomSkills,
            creationType,
            setCreationType,
            skillTypesFilter,
            setSkillTypesFilter,
            skillCategoryIdsFilter,
            setSkillCategoryIdsFilter,
            occupationIdsFilter,
            setOccupationIdsFilter,
        }}
        >
            {children}
        </SkillsContext.Provider>
    );
};
